import { useEffect, useState } from 'react';
import CharCount from '../../charCount/CharCount';

export default function UserDetails({ bookingData, handleUser }) {
    const [seatCount, setSeatCount] = useState(bookingData?.people || 0);

    // Sync seat count
    useEffect(() => {
        setSeatCount(bookingData?.people || 0);
    }, [bookingData?.people]);

    // Initialize userDetails safely
    useEffect(() => {
        if (!bookingData?.people) return;

        const users = Array.from({ length: bookingData.people }, (_, index) => {
            return (
                bookingData?.userDetails?.[index] || {
                    name: '',
                    age: '',
                    sex: 'Select',
                    emailId: '',
                    countryCode: '+91',
                    phoneNumber: ''
                }
            );
        });

        handleUser(users);
    }, [bookingData?.people]);

    if (bookingData?.people === -1) return null;

    return (
        <div className='orgAddBoUserDiv'>
            {Array.from({ length: seatCount }).map((_, peopleIndex) => {
                const user = bookingData?.userDetails?.[peopleIndex] || {};

                return (
                    <div key={peopleIndex} className='reviewBoInfoUserDiv'>
                        <div className='reviewBoInfoNameAge'>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Name</label>
                                <input
                                    value={user.name || ''}
                                    name='name'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    type='text'
                                    placeholder={`Person ${peopleIndex + 1} name`}
                                    className='reviewBoInfoInput'
                                />
                                <CharCount string={user.name || ''} min={3} limit={30} />
                            </div>

                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Age</label>
                                <input
                                    value={user.age || ''}
                                    name='age'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    type='number'
                                    placeholder="Person's age"
                                    className='reviewBoInfoInput'
                                />
                            </div>
                        </div>

                        <div className='reviewBoInfoNameAge'>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Sex</label>
                                <select
                                    value={user.sex || 'Select'}
                                    name='sex'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    className='reviewBoInfoInput'
                                >
                                    <option value='Select'>Select</option>
                                    <option value='Male'>Male</option>
                                    <option value='Female'>Female</option>
                                    <option value='Others'>Others</option>
                                </select>
                            </div>

                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Email</label>
                                <input
                                    value={user.emailId || ''}
                                    name='emailId'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    type='text'
                                    placeholder={`Email Id of person ${peopleIndex + 1}`}
                                    className='reviewBoInfoInput'
                                />
                            </div>
                        </div>

                        <div className='reviewBoInfoNameAge'>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Country code</label>
                                <select
                                    value={user.countryCode || '+91'}
                                    name='countryCode'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    className='reviewBoInfoInput'
                                >
                                    <option value='+91'>+91</option>
                                </select>
                            </div>

                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Phone Number</label>
                                <input
                                    value={user.phoneNumber || ''}
                                    name='phoneNumber'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    type='text'
                                    placeholder='Mobile Number'
                                    className='reviewBoInfoInput'
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
